document.addEventListener('DOMContentLoaded', function () {
  const menu = document.querySelector('.mobile-menu');
  if (menu) menu.addEventListener('click', function () { document.querySelector('.nav')?.classList.toggle('is-open'); });

  const gallery = document.querySelector('.product-gallery--large');
  const image = gallery?.querySelector('[data-gallery-main]');
  const imageData = document.querySelector('[data-product-images]');
  if (gallery && image && imageData) {
    const images = JSON.parse(imageData.textContent || '[]');
    let startX = 0;
    gallery.addEventListener('touchstart', function (event) { startX = event.changedTouches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (event) {
      const distance = event.changedTouches[0].clientX - startX;
      if (Math.abs(distance) < 35 || images.length < 2) return;
      let current = images.findIndex(function (url) { return image.src.indexOf(url.split('?')[0]) !== -1; });
      if (current < 0) current = 0;
      const next = (current + (distance < 0 ? 1 : -1) + images.length) % images.length;
      image.src = images[next];
      document.querySelectorAll('.product-thumb').forEach(function (thumb, index) { thumb.classList.toggle('is-active', index === next); });
    }, { passive: true });
  }

  const discount = document.querySelector('.discount-pill');
  const variantData = document.querySelector('[data-product-variants]');
  if (discount && variantData) {
    const first = JSON.parse(variantData.textContent || '[]')[0];
    const price = Number(first?.price || 0);
    const compare = Number(first?.compare_at_price || first?.compareAtPrice || 0);
    if (compare > price) discount.textContent = '-' + Math.round((1 - price / compare) * 100) + '%';
  }

});


// Cartpanda's Shopify importer created the products, but did not bind the
// Shopify variant IDs (the Cartpanda cart endpoint returns "Variant not found").
// These IDs are the live Cartpanda variants returned by its product API,
// kept in the same order as the published Shopify variants.
var CARTPANDA_VARIANT_IDS = {
  'projetor-de-lua-lunne': [213325660, 213325661],
  'projetor-hy300-lunne': [213325074],
  'luminaria-ceu-estrelado-lunne': [213356944, 213356946, 213356947, 213356948],
  'luminaria-por-do-sol-lunne': [213356940, 213356942],
  'projetor-aurora-boreal-lunne': [213356945],
  'projetor-astronauta-lunne': [213356939, 213356941, 213356943]
};
var CARTPANDA_CHECKOUT_HOST = 'https://pagamento.lunnebrasil.shop';

function cartpandaDirectUrl(form, quantity) {
  var handle = location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  var ids = handle && CARTPANDA_VARIANT_IDS[handle];
  var variantsNode = document.querySelector('[data-product-variants]');
  if (!ids || !variantsNode) return '';
  var variants = JSON.parse(variantsNode.textContent || '[]');
  var selectedId = Number(form.querySelector('[data-variant-id]')?.value);
  var index = variants.findIndex(function (variant) { return Number(variant.id) === selectedId; });
  if (index < 0 || !ids[index]) return '';
  return CARTPANDA_CHECKOUT_HOST + '/checkout/' + ids[index] + ':' + Math.max(1, quantity);
}

// Send the selected Shopify variant to Cartpanda's real checkout. The native
// Shopify checkout remains the safe fallback if a future product is not in the
// synchronized map yet.
function submitProductAndCheckout(form) {
  if (!form) return;
  const id = form.querySelector('[data-variant-id]')?.value;
  const quantity = Number(form.querySelector('[data-quantity]')?.value || 1);
  if (!id) return;
  const button = form.querySelector('[data-add-to-cart]');
  if (button) { button.disabled = true; button.dataset.originalLabel = button.textContent; button.textContent = 'Aguarde...'; }
  var directUrl = cartpandaDirectUrl(form, quantity);
  if (directUrl) { window.location.href = directUrl; return; }
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] }) })
    .then(function (response) { if (!response.ok) throw new Error('Falha ao adicionar o produto'); return response.json(); })
    .then(function () { return fetch('/cart.json').then(function (response) { if (!response.ok) throw new Error('Falha ao carregar o carrinho'); return response.json(); }); })
    .then(function (cart) {
      (cart.items || []).forEach(function (item) { delete item.product_description; });
      return fetch('https://bellizzi.mycartpanda.com/shopify/cart', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ shop: 'jmvbdb-xb.myshopify.com', host_name: 'jmvbdb-xb.myshopify.com', cart_payload: cart }) })
        .then(function (response) { return response.json(); })
        .then(function (checkout) { if (checkout.active && checkout.checkout_direct_url) { window.location.href = checkout.checkout_direct_url; } else { window.location.href = '/checkout'; } });
    })
    .catch(function () { window.location.href = '/checkout'; });
}

document.addEventListener('click', function (event) {
  const quick = event.target.closest('[data-quick-add]');
  if (!quick) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const form = document.createElement('form');
  form.method = 'post';
  form.action = '/cart/add';
  const id = document.createElement('input');
  id.type = 'hidden';
  id.name = 'id';
  id.value = quick.closest('article')?.querySelector('select')?.value || quick.dataset.quickAdd;
  const returnTo = document.createElement('input');
  returnTo.type = 'hidden';
  returnTo.name = 'return_to';
  returnTo.value = '/cart';
  form.append(id, returnTo);
  document.body.appendChild(form);
  form.submit();
}, true);

document.addEventListener('click', function (event) {
  const option = event.target.closest('[data-option-value]');
  if (!option) return;
  setTimeout(function () {
  const page = document.querySelector('.product-page');
  const imagesNode = document.querySelector('[data-product-images]');
  if (!page || !imagesNode) return;
  const colorField = Array.from(document.querySelectorAll('.product-option')).find(function (field) { return (field.querySelector('legend')?.textContent || '').toLowerCase().includes('cor'); });
  const color = colorField?.querySelector('.is-selected')?.dataset.optionValue?.toLowerCase() || '';
  const handle = page.dataset.productHandle || '';
  const orders = {
    'sandalia-cloud-slide-pe-na-areia': ['azul','branco','bege','preto'],
    'sandalia-soft-cloud-pe-na-areia': ['rosa','preto','bege','laranja'],
    'chinelo-anatomico-pe-na-areia': ['laranja','preto','bege','rosa','amarelo'],
    'sandalia-comfort-easy-pe-na-areia': ['laranja','azul']
  };
  const index = (orders[handle] || []).findIndex(function (name) { return color.includes(name); });
  if (index < 0) return;
  const images = JSON.parse(imagesNode.textContent || '[]');
  const main = document.querySelector('[data-gallery-main]');
  if (main && images[index]) main.src = images[index];
  document.querySelectorAll('.product-thumb').forEach(function (thumb, thumbIndex) { thumb.classList.toggle('is-active', thumbIndex === index); });
  }, 0);
});

document.addEventListener('click', function (e) {
  const quick = e.target.closest('[data-quick-add]');
  if (quick) { const selected = quick.closest('article')?.querySelector('select')?.value || quick.dataset.quickAdd; fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(selected), quantity: 1 }] }) }).then(function () { location.reload(); }); return; }
  const copy = e.target.closest('[data-copy-coupon]');
  if (copy) { e.preventDefault(); navigator.clipboard.writeText(copy.dataset.copyCoupon).then(function () { const old = copy.innerHTML; copy.innerHTML = 'COPIADO ✓'; setTimeout(function () { copy.innerHTML = old; }, 1600); }); return; }
  const thumb = e.target.closest('[data-gallery-image]');
  if (thumb) { const main = document.querySelector('[data-gallery-main]'); if (main) { main.src = thumb.dataset.galleryImage; document.querySelectorAll('.product-thumb').forEach(function (x) { x.classList.remove('is-active'); }); thumb.classList.add('is-active'); } return; }
  const bundle = e.target.closest('[data-bundle-quantity]');
  if (bundle) { document.querySelectorAll('[data-bundle-quantity]').forEach(function (x) { x.classList.remove('is-selected'); }); bundle.classList.add('is-selected'); const quantity = document.querySelector('[data-quantity]'); if (quantity) quantity.value = bundle.dataset.bundleQuantity; return; }
  const option = e.target.closest('[data-option-value]');
  if (option) { const form = option.closest('[data-variant-picker]'); form.querySelectorAll('[data-option-name="' + CSS.escape(option.dataset.optionName) + '"]').forEach(function (x) { x.classList.remove('is-selected'); }); option.classList.add('is-selected'); const variants = JSON.parse(document.querySelector('[data-product-variants]').textContent); const selected = {}; form.querySelectorAll('.product-option').forEach(function (field) { const chosen = field.querySelector('.is-selected'); if (chosen) selected[chosen.dataset.optionName] = chosen.dataset.optionValue; }); const names = JSON.parse(document.querySelector('[data-product-option-names]').textContent); const match = variants.find(function (variant) { return variant.options && variant.options.every(function (value, i) { return value === selected[names[i]]; }); }); if (match) { form.querySelector('[data-variant-id]').value = match.id; lunneAtualizaPreco(match); const sticky = document.querySelector('[data-sticky-variant]'); if (sticky) sticky.textContent = match.title; } return; }
  if (e.target.closest('[data-size-guide]')) { document.querySelector('[data-size-dialog]')?.showModal(); return; }
  if (e.target.closest('[data-size-close]')) { document.querySelector('[data-size-dialog]')?.close(); return; }
  if (e.target.closest('[data-sticky-change]')) { document.querySelector('.product-form')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
  if (e.target.closest('[data-sticky-add]')) { submitProductAndCheckout(document.querySelector('[data-variant-picker]')); return; }
  const add = e.target.closest('[data-add-to-cart]');
  if (add) { e.preventDefault(); submitProductAndCheckout(add.closest('form')); }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a').forEach(function (link) {
    if (link.textContent.trim() === 'Rastrear Pedido') link.href = 'https://rastreamento.correios.com.br/app/index.php';
  });
  document.addEventListener('contextmenu', function (event) { event.preventDefault(); });
  document.addEventListener('keydown', function (event) {
    var key = String(event.key || '').toLowerCase();
    if (key === 'f12' || (event.ctrlKey && event.shiftKey && ['i','j','c'].includes(key)) || (event.ctrlKey && key === 'u')) event.preventDefault();
  });
  const dialog = document.querySelector('[data-size-dialog]');
  if (!dialog) return;
  const sizes = ['34/35', '36/37', '38/39', '40/41', '42/43', '44/45', '46/47'];
  const ranges = {'34/35':[22,22.9],'36/37':[23,23.9],'38/39':[24,24.9],'40/41':[25,25.9],'42/43':[26,26.9],'44/45':[27,27.9],'46/47':[28,28.9]};
  const charts = {Nike:{33.5:22,34:22.4,35:22.9,36:23.7,37:24.1,38:25,39:25.4,40:26.2,41:26.7,42:27.5,43:27.9},Adidas:{34:22.5,35:22.9,36:23.8,37:24.2,38:24.6,39:25,40:25.9,41:26.7,42:27.1,43:28},Puma:{34:22.5,35:23,36:24,37:25,38:25.5,39:26.5,40:27,41:28},Vans:{34:20.8,35:21.3,36:22.3,37:23.3,38:24.3,39:25.3,40:25.8,41:26.8,42:27.3,43:27.8},Reebok:{34:23.3,35:23.5,36:24,37:24.5,38:25,39:25.5,40:26.5,41:27.5,42:28,43:29},'New Balance':{34:22.5,35:23,36:23.5,37:24,38:24.5,39:25,40:26,41:26.8,42:27,43:28},Havaianas:{33:21.4,34:22,35:22.7,36:23.3,37:24,38:24.7,39:25.4,40:26,41:26.7,42:27.3,43:28},Arezzo:{33:22,34:22.6,35:23.3,36:24,37:24.6,38:25.3,39:26,40:26.6},Melissa:{33:21.8,34:22.2,35:23,36:24,37:25,38:25.5,39:26,40:26.5,41:27,42:28,43:28.8}};
  const cm = ranges;
  let step = 1;
  let selectedBrand = '';
  let selectedSize = 36;
  let selectedFit = 'medida';
  let selectedWidth = 'medio';
  const setStep = function (next) {
    step = next;
    dialog.dataset.wizardStep = step;
    dialog.querySelectorAll('[data-wizard-step]').forEach(function (section) { section.hidden = Number(section.dataset.wizardStep) !== step; });
    dialog.querySelectorAll('[data-wizard-steps] i').forEach(function (item, index) { item.classList.toggle('is-active', index < Math.min(step, 4)); item.textContent = index < step && step > 1 ? '✓' : String(index + 1); });
  };
  const resultData = function () {
    const chart = charts[selectedBrand] || charts.Nike;
    let foot = chart[selectedSize] || 24;
    foot += selectedFit === 'justo' ? .4 : selectedFit === 'folgado' ? -.4 : 0;
    let result = sizes.find(function (token) { return foot >= ranges[token][0] && foot <= ranges[token][1]; }) || sizes.reduce(function (best, token) { return Math.abs(((ranges[token][0] + ranges[token][1]) / 2) - foot) < Math.abs(((ranges[best][0] + ranges[best][1]) / 2) - foot) ? token : best; }, sizes[0]);
    if (selectedWidth === 'largo' && result !== sizes[sizes.length - 1]) result = sizes[sizes.indexOf(result) + 1];
    if (selectedWidth === 'estreito' && result !== sizes[0]) result = sizes[sizes.indexOf(result) - 1];
    const variants = JSON.parse(document.querySelector('[data-product-variants]')?.textContent || '[]');
    const names = JSON.parse(document.querySelector('[data-product-option-names]')?.textContent || '[]');
    const sizeIndex = Math.max(0, names.findIndex(function (name) { return String(name).toLowerCase().includes('tamanho') || String(name).toLowerCase().includes('size'); }));
    const available = Array.from(new Set(variants.map(function (variant) { return variant.options?.[sizeIndex] || (variant.title.match(/\d{2}\/\d{2}/) || [])[0]; }).filter(Boolean)));
    const midpoint = function (token) { const nums = String(token).match(/\d+/g) || []; return nums.length > 1 ? (Number(nums[0]) + Number(nums[1])) / 2 : Number(nums[0]) || 0; };
    const productSize = available.includes(result) ? result : (available.slice().sort(function (a, b) { return Math.abs(midpoint(a) - midpoint(result)) - Math.abs(midpoint(b) - midpoint(result)); })[0] || result);
    return {size: result, productSize: productSize, foot: foot};
  };
  const resultSize = function () { return resultData().size; };
  const updateBrandSizes = function () {
    const values = Object.keys(charts[selectedBrand] || charts.Nike).map(Number).sort(function (a, b) { return a - b; });
    const grid = dialog.querySelector('.wizard-sizes');
    if (!grid) return;
    grid.innerHTML = values.map(function (value) { return '<button type="button" data-wizard-size="' + value + '">' + String(value).replace('.', ',') + '</button>'; }).join('');
  };
  const markChoice = function (button, attribute) {
    const labels = {justo: 'Justo', medida: 'Na medida', folgado: 'Folgado', estreito: 'Estreito', medio: 'Médio', largo: 'Largo'};
    dialog.querySelectorAll('[' + attribute + ']').forEach(function (item) {
      const key = item.dataset[attribute.slice(5)];
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      item.textContent = (selected ? '◉ ' : '◯ ') + (labels[key] || key);
    });
  };
  const selectVariant = function () {
    const recommendation = resultData();
    const form = document.querySelector('[data-variant-picker]');
    const variants = JSON.parse(document.querySelector('[data-product-variants]')?.textContent || '[]');
    const color = form?.querySelector('.product-option .is-selected')?.dataset.optionValue || '';
    const target = Number(recommendation.size.split('/')[0]) + 0.5;
    const pool = variants.filter(function (variant) { return !color || variant.title.includes(color); });
    const candidates = pool.length ? pool : variants;
    const exact = candidates.find(function (variant) { return variant.title.replace(/\s+/g, '').includes(String(recommendation.productSize).replace(/\s+/g, '')); });
    const match = exact || candidates.slice().sort(function (a, b) {
      const ap = a.title.match(/(\d{2})\s*\/\s*(\d{2})/); const bp = b.title.match(/(\d{2})\s*\/\s*(\d{2})/);
      const am = ap ? (Number(ap[1]) + Number(ap[2])) / 2 : 999; const bm = bp ? (Number(bp[1]) + Number(bp[2])) / 2 : 999;
      return Math.abs(am - target) - Math.abs(bm - target);
    })[0];
    if (!match || !form) return;
    form.querySelector('[data-variant-id]').value = match.id;
    const pair = match.title.match(/(\d{2})\s*\/\s*(\d{2})/);
    const actual = pair ? pair[0].replace(/\s+/g, '') : '';
    form.querySelectorAll('[data-option-value]').forEach(function (button) { button.classList.toggle('is-selected', actual && button.dataset.optionValue.replace(/\s+/g, '') === actual || color && button.dataset.optionValue === color); });
    const sticky = document.querySelector('[data-sticky-variant]');
    if (sticky) sticky.textContent = match.title;
  };
  dialog.addEventListener('click', function (event) {
    const brand = event.target.closest('[data-brand]');
    if (brand) { selectedBrand = brand.textContent.trim(); selectedSize = null; updateBrandSizes(); const subtitle = dialog.querySelector('[data-wizard-step="2"] .wizard-subtitle'); if (subtitle) subtitle.innerHTML = 'Escolha seu tamanho na <strong>' + selectedBrand + '</strong>'; dialog.querySelectorAll('[data-brand]').forEach(function (button) { button.classList.toggle('is-selected', button === brand); }); dialog.querySelector('[data-wizard-step="1"] [data-wizard-next]').disabled = false; return; }
    const size = event.target.closest('[data-wizard-size]');
    if (size) { selectedSize = Number(size.dataset.wizardSize); dialog.querySelectorAll('[data-wizard-size]').forEach(function (button) { button.classList.toggle('is-selected', button === size); }); const sizeNext = dialog.querySelector('[data-wizard-step="2"] [data-wizard-next]'); if (sizeNext) { sizeNext.disabled = false; sizeNext.removeAttribute('disabled'); } return; }
    const fit = event.target.closest('[data-fit]');
    if (fit) { selectedFit = fit.dataset.fit; markChoice(fit, 'data-fit'); return; }
    const width = event.target.closest('[data-width]');
    if (width) { selectedWidth = width.dataset.width; markChoice(width, 'data-width'); return; }
    const tab = event.target.closest('[data-wizard-tab]');
    if (tab) { const table = tab.dataset.wizardTab === 'table'; dialog.querySelector('.wizard-table').hidden = !table; dialog.querySelectorAll('[data-wizard-step]').forEach(function (section) { section.hidden = table || Number(section.dataset.wizardStep) !== step; }); dialog.querySelectorAll('[data-wizard-tab]').forEach(function (button) { button.classList.toggle('is-active', button === tab); }); return; }
    if (event.target.closest('[data-wizard-known]')) { dialog.querySelector('[data-wizard-tab="table"]').click(); return; }
    const next = event.target.closest('[data-wizard-next]');
    if (next) { if (step === 4) { const result = resultData(); dialog.querySelector('[data-wizard-result-size]').textContent = result.size; dialog.querySelector('[data-wizard-result-cm]').textContent = result.foot.toFixed(1).replace('.', ',') + ' cm'; setStep(5); } else setStep(step + 1); return; }
    if (event.target.closest('[data-wizard-result]')) { const result = resultData(); dialog.querySelector('[data-wizard-result-size]').textContent = result.productSize; dialog.querySelector('[data-wizard-result-cm]').textContent = result.foot.toFixed(1).replace('.', ',') + ' cm'; setStep(5); return; }
    if (event.target.closest('[data-wizard-reset]')) { selectedBrand = ''; selectedSize = 36; selectedFit = 'medida'; selectedWidth = 'medio'; dialog.querySelectorAll('.is-selected').forEach(function (button) { button.classList.remove('is-selected'); }); dialog.querySelector('[data-wizard-step="1"] [data-wizard-next]').disabled = false; dialog.querySelector('[data-wizard-step="2"] [data-wizard-next]').disabled = false; setStep(1); return; }
    if (event.target.closest('[data-wizard-select]')) { selectVariant(); dialog.close(); }
  });
  // Keep the fit/width controls clickable even when the dialog content is
  // re-rendered or an inherited theme layer interferes with delegation.
  dialog.querySelectorAll('[data-fit]').forEach(function (button) {
    button.addEventListener('click', function () {
      selectedFit = button.dataset.fit;
      markChoice(button, 'data-fit');
    });
  });
  dialog.querySelectorAll('[data-width]').forEach(function (button) {
    button.addEventListener('click', function () {
      selectedWidth = button.dataset.width;
      markChoice(button, 'data-width');
    });
  });
  dialog.addEventListener('close', function () { setStep(1); });
  setStep(1);
});

// Atualiza preço, "de", % de desconto, parcela e PIX ao trocar de variante (kit)
function lunneAtualizaPreco(v) {
  var brl = function (c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); };
  var q = function (s) { return document.querySelector(s); };
  if (q('[data-price]')) q('[data-price]').textContent = brl(v.price);
  if (q('[data-installment]')) q('[data-installment]').textContent = brl(Math.round(v.price / 3));
  if (q('[data-pix]')) q('[data-pix]').textContent = brl(Math.round(v.price * 0.95));
  var tem = v.compare_at_price && v.compare_at_price > v.price;
  if (q('[data-compare]')) { q('[data-compare]').hidden = !tem; if (tem) q('[data-compare]').textContent = brl(v.compare_at_price); }
  if (q('[data-pill]')) { q('[data-pill]').hidden = !tem; if (tem) q('[data-pill]').textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
}

// Galeria do Instagram em tempo real (via Worker com cache de 1 h; token nunca vai para o navegador)
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ig-feed]').forEach(function (box) {
    fetch('https://operacao.suportebrazika.workers.dev/ig-feed?u=' + encodeURIComponent(box.dataset.igFeed))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        (d.itens || []).slice(0, 12).forEach(function (m) {
          var a = document.createElement('a'); a.href = m.url; a.target = '_blank'; a.rel = 'noopener'; if (m.video) a.className = 'is-video';
          var img = document.createElement('img'); img.src = m.img; img.loading = 'lazy'; img.alt = 'Post do Instagram @' + d.perfil; img.width = 270; img.height = 480;
          a.appendChild(img); box.appendChild(a);
        });
        if (!(d.itens || []).length) box.remove();
      }).catch(function () { box.remove(); });
  });
});
